import React, { Fragment } from 'react'
import { enUS, he } from "date-fns/locale";
import DatePicker from 'react-datepicker';

function DatePickerComponent({ includeDates, setValue, getValues, errorMessage }) {
    const lang = new URLSearchParams(window.location.search).get("lang") || "en";
    const firstAvailableDate = includeDates.find(d => d);

    return (
        <Fragment>
            <div className='d-block'>
                <DatePicker
                    inline
                    minDate={new Date()}
                    locale={lang === 'he' ? he : enUS}
                    openToDate={firstAvailableDate}
                    includeDates={includeDates}
                    selected={getValues('dailyInventoryDate')}
                    onChange={(date) => setValue('dailyInventoryDate', date)}
                />
            </div>
            {!!errorMessage && (
                <span role="alert" className="error">{errorMessage}</span>
            )}
        </Fragment>
    )
}
export default DatePickerComponent;